import { Flex } from "@redotech/redo-web/flex";
import { ReactNode } from "react";

export function StickyFooter({
  children,
  bgColor = "primary",
  sticky = true,
}: {
  children: ReactNode;
  bgColor?: "primary" | "secondary";
  sticky?: boolean;
}) {
  return (
    <Flex
      bgColor={bgColor}
      bottom={sticky ? "0" : undefined}
      data-ui="sticky-footer"
      flexDirection="column"
      gap="none"
      pb="3xl"
      position={sticky ? "sticky" : undefined}
      w="full"
    >
      {children}
    </Flex>
  );
}
